import { IUpdateClientKeywordsBodyParams, IUpdateTypeContentBodyParams } from "types/content"

export const formatKeywordsData = (keywordsObj: any): IUpdateClientKeywordsBodyParams => {
  const keywordsArray: IUpdateClientKeywordsBodyParams = []

  for (const keyword in keywordsObj) {
    keywordsArray.push({
      key: keyword,
      value: keywordsObj[keyword]
    })
  }
 
  return keywordsArray
}

export const formatContentTypes = (contentTypesObj: any) => {
  const contentTypesArray: IUpdateTypeContentBodyParams = []

  for (const contentType in contentTypesObj) {
    const entityType = contentType.split('-')[1]
    const objectType = contentType.split('-')[0]
    const key = contentType.split('-')[2]
    for (const lang in contentTypesObj[contentType]) {
      contentTypesArray.push({
        lang,
        entityType,
        objectType,
        key: Number(key),
        value: contentTypesObj[contentType][lang]
      })
    }
  }

  return contentTypesArray
}